import React, { Component } from "react";
import { Link } from "react-router-dom";
export class EnquiresSearch extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
    this.state = {
      fields: [
        {
          name: "start_date",
          label: "Start Date",
          type: "date",
        },
        {
          name: "end_date",
          label: "End Date",
          type: "date",
        },
      ],
    };
  }

  trimObjectValues(obj) {
    const trimmedObj = {};
    for (const key in obj) {
      if (typeof obj[key] === "string") {
        trimmedObj[key] = obj[key].trim();
      } else {
        trimmedObj[key] = obj[key];
      }
    }
    return trimmedObj;
  }

  onSearch() {
    let data = this.refs.form.form.current.getData();
    // console.log("onSearch formData", data);

    data = this.trimObjectValues(data);
    data = Object.filter(data, (val) => val);
    // console.log("data on search", data);
    this.props.onSearch && this.props.onSearch(data);
  }

  clearTextData = () => {
    this.setState({
      fields: this.state.fields.map((field) => ({ ...field, value: "" })),
    });

    let data = this.refs.form.form.current.getData();
    data = Object.filter(data, (val) => "");

    this.props.onSearch && this.props.onSearch(data);
  };

  componentDidMount() {}

  downloadFile() {
    let data = this.refs.form.form.current.getData();
    console.log({ data });

    this.props.api
      .apiExportUserEnquiry(data)
      .then(async (res) => {
        if (res) {
          let data = await res;
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute(
            "download",
            `enquiry_export_${new Date().toDate()}.xlsx`
          );
          link.click();
        }
      })
      .catch((error) => {
        toast.error("There is some error while downloading");
      });
  }

  render() {
    let { fields } = this.state;

    return (
      <AppForm className="row filter-row" ref="form">
        {fields.map((field, i) => (
          <div className="col-sm-6 col-md-3" key={i}>
            <AppInputFocus {...field}></AppInputFocus>
          </div>
        ))}
        <div className="col-sm-6 col-md-3">
          <button
            className="btn btn-success btn-block w-100"
            onClick={() => this.onSearch()}
          >
            Search
          </button>
        </div>
        <div className="col-sm-6 col-md-3">
          <Link
            className="btn w-100 bg-transparent col col-md-1 ml-auto grey ms-2 me-2 float-right"
            onClick={(...args) => this.downloadFile(...args)}
          >
            <i className="fa fa-download pr-2"></i>
            Download Excel
          </Link>
        </div>
        <span className="clear-all" onClick={() => this.clearTextData()}>
          Clear Filter
        </span>
      </AppForm>
    );
  }
}

export default connect(EnquiresSearch);
